export const povezave = {
  BASE_URL_T2_STRAN: 'https://www.t-2.net/',
  BASE_URL_T2_KLUB: 'https://klub.t-2.net/',
  BASE_URL_T2_KLUB_POLITIKA: 'https://klub.t-2.net/politika-zasebnosti.aspx',
  BASE_URL_ANDROID_TV_POVEZAVA: 'https://play.google.com/store/apps/details?id=tv.perception.clients.tv.android',
  BASE_URL_T2TGO_IOS_POVEZAVA: 'https://apps.apple.com/si/app/t-2-tv2go/id413642714',
  BASE_URL_T2TGO_ANDROID_POVEZAVA: 'https://play.google.com/store/apps/details?id=tv.perception.clients.mobile.android&hl=sl',
  BASE_URL_PORABA_IOS_POVEZAVA: 'https://apps.apple.com/si/app/t-2-poraba/id1154431286',
  BASE_URL_PORABA_ANDROID_POVEZAVA: 'https://play.google.com/store/apps/details?id=com.t2.mobile.usage&hl=sl',
  BASE_URL_HORIZONT_IOS_POVEZAVA: 'https://apps.apple.com/si/app/t-2-horizont/id1086545076',
  BASE_URL_HORIZONT_ANDROID_POVEZAVA: 'https://play.google.com/store/apps/details?id=com.globtim.t2avditorij&hl=sl',
  BASE_URL_AVDITORIJ: 'https://avditorij.t-2.net/',
  BASE_URL_POSLOVALNICE: 'https://www.t-2.net/poslovalnice',
  BASE_URL_ANKETA: 'https://anketa.t-2.net/index.php/783157?lang=sl',
  BASE_URL_SPLOSNI_POGOJI_PODJETJA: 'https://www.t-2.net/splosni-pogoji-podjetja',
  BASE_URL_APLIKACIJA_TV: 'https://www.t-2.net/aplikacija-t-2-tv',
  BASE_URL_SEZNAM_NAPRAV: 'https://www.t-2.net/seznam-podprtih-naprav-za-aplikacijo-t-2-tv',
  BASE_URL_SPLOSNI_POGOJI_POSLOVANJA: 'https://www.t-2.net/sites/www.t2.si/files/files/uploads/article/splosni_pogoji_poslovanja_t2_01072018.pdf',
  BASE_URL_SPLOSNI_POGOJI_UPORABE_STORITEV_PREKO_MOBILNEGA_OMREZJA: 'https://www.t-2.net/sites/www.t2.si/files/files/uploads/article/splosni_pogoji_uporabe_storitev_preko_mobilnega_omrezja_veljavni_od_01.04.2019_0.pdf',
  BASE_URL_SPLOSNI_POGOJI_POGODBE_NA_DALJAVO: 'https://www.t-2.net/sites/www.t2.si/files/files/uploads/article/splosni_pogoji_pogodbe_na_daljavo.pdf',
  BASE_URL_SPLOSNI_POGOJI_UPORABE_PAKETOV: 'https://www.t-2.net/sites/www.t2.si/files/files/uploads/article/splosni_pogoji_pogoji_uporaba_paketov_t2_032019.pdf',
  BASE_URL_NASTAVITEV_PODATKOVNIH_MMS_PARAMETROV: 'https://www.t-2.net/nastavitev-podatkovnih-mms-parametrov',
  BASE_URL_ADMINISTRATIVNE_STORITVE_ZASEBNO: 'https://www.t-2.net/administrativne-storitve-zasebni',
  BASE_URL_WEBMAIL: 'https://webmail.t-2.net',
  BASE_URL_CENIK_TELEVIZIJA: 'https://www.t-2.net/cenik-za-televizijo',
  BASE_URL_CENIK_PODPORA: 'https://www.t-2.net/podpora-ceniki',
  BASE_URL_PODPORA: 'https://www.t-2.net/podpora',
  BASE_URL_SPLOSNI_POGOJI: 'https://www.t-2.net/splosni-pogoji-podjetja',
  BASE_URL_RAZLAGA_RACUNA: 'https://enovice.t-2.net/RazlagaRacuna/Razlaga_racuna.pdf',
  BASE_URL_TV_APLIKACIJA: 'https://www.t-2.net/aplikacija-t-2-tv',
  BASE_URL_FIRE_TV: 'https://www.amazon.com/T-2-TV/dp/B07QKTLL1J/',
  BASE_URL_SPREMEMBA_GESLA_TV2GO: 'https://tv2go.t-2.net/account/locking',
  BASE_URL_UREJANJE_PROFILA: 'https://tv2go.t-2.net/settings/profile_settings',
  BASE_URL_UPORABNE_FUNKCIJE_T2_TELEVIZIJE: 'https://www.t-2.net/zabavne-uporabne-funkcije-t-2-televizije',
  BASE_URL_KAJ_VSE_OMOGOCA_UPORABNISKI_PROFIL: 'https://www.t-2.net/kaj-vse-omogoca-uporabniski-profil',
  BASE_URL_HORIZONT_PORTAL: 'https://horizont.t-2.net/',
  BASE_URL_HORIZONT_SPLETNA_STRAN: 'https://www.t-2.net/horizont',
  BASE_URL_MOBILNO_GOSTOVANJE: 'https://www.t-2.net/mobilno-gostovanje',
  BASE_URL_ELEKTRONSKA_POSTA: 'https://www.t-2.net/elektronska-posta',
  BASE_URL_VARNOSTNI_PAKET_PANDA: 'https://www.t-2.net/varnostni-paket-panda',
  BASE_URL_PREUSMERITEV_NA_STACIONARNIH_TELEFONSKIH_STEVILKAH: 'https://www.t-2.net/kratka-navodila-za-preusmeritve-na-stacionarnih-telefonskih-stevilkah',
  BASE_URL_NADZOR_PORABE_MOBILNE_TELEFONIJE: 'https://www.t-2.net/nadzor-porabe-mobilne-telefonije',
  BASE_URL_NASTAVITEV_PREUSMERITVE_KLICEV: 'https://www.t-2.net/ali-lahko-nastavim-preusmeritev-klicev',
  BASE_URL_CENA_KLICEV: 'https://www.t-2.net/cena-klicev-sms-sporocil-v-nacionalnem-omrezju',
  BASE_URL_APLIKACIJA_TV_GO: 'https://www.t-2.net/aplikacija-tv2go',
  BASE_URL_MOBILE_APLIKACIJA_T2_TV_GO: 'https://www.t-2.net/mobilna-televizija-t-2-tv2go',
  BASE_URL_TV_TRIKI_CASOVNIH_FUNKCIJ: 'https://www.t-2.net/uporabni-triki-tv-casovnih-funkcij',
  BASE_URL_TV_CASOVNIH_FUNKCIJ: 'https://www.t-2.net/tv-casovne-funkcije',
  BASE_URL_PRIMERJALNIK_PROGRAMSKIH_SHEM: 'https://www.t-2.net/primerjalnik-programskih-shem',
  BASE_URL_DODATNI_TV_PROGRAMSKI_PAKETI: 'https://www.t-2.net/dodatni-tv-programski-paketi',
  BASE_URL_RACUN_STEVILKA_KUPCA: 'https://enovice.t-2.net/RazlagaRacuna/Racun_stevilka_kupca.pdf',
  BASE_URL_VARNOST_OSEBNIH_PODATKOV: 'https://www.t-2.net/varnost-osebnih-podatkov',
  BASE_URL_NASLOVNA_STRAN: '/Domov/NaslovnaStran',
  NAME_NASLOVNA_STRAN: 'NaslovnaStran',
  BASE_URL_MOJ_T_2: 'https://www.t-2.net/moj-t-2',
  BASE_URL_OTT_TV_T2_SUBSCRIPTION: 'https://tv.t-2.net/app/subscription',
  BASE_URL_CENIKI_T_2_STORITEV: 'https://www.t-2.net/podpora-ceniki',
  BASE_URL_CENIKI_T_2_TELEFONIJE: 'https://www.t-2.net/ceniki-t-2-telefonije',
  BASE_URL_GOSTOVANJE_V_EVROPSKI_UNIJI: 'https://www.t-2.net/gostovanje-v-evropski-uniji',
  BASE_URL_POMOC_OB_POVEZAVI_NAROCNINE: 'https://www.t-2.net/potrebujete-pomoc-ob-povezavi-narocnine',
  BASE_URL_PRAVICE_UPORABNIKI: 'https://www.t-2.net/pravice-uporabniki',
  BASE_URL_PROSTOR_V_OBLAKU: 'https://www.t-2.net/prostor-v-oblaku-t-2-horizont',
  BASE_URL_SPLOSNI_POGOJI_T2_SCIT: 'https://www.t-2.net/sites/www.t2.si/files/splosni_pogoji_uporabe_storitve_t-2_scit_koncna_verzija_1.9.2024.pdf',
  BASE_URL_UPRAVLJANJE_S_T2_ID: 'https://www.t-2.net/upravljanje-s-t-2-id',
  BASE_URL_MAGAZIN: 'https://www.t-2.net/t-2-magazin/vse',
  BASE_URL_NAVODILA_PREUSMERITVE: 'https://www.t-2.net/nadzor-porabe-mobilne-telefonije',
  BASE_URL_REGISTRACIJA: 'https://login.t-2.net/register',
  GDPR: 'https://www.t-2.net/informacije-o-obdelavi-osebnih-podatkov-v-druzbi-t-2-doo'
}



// WEBPACK FOOTER //
// ./src/assets/js/Povezave/povezave.js